/* __next_internal_client_entry_do_not_use__ Globe auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1592))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.797Z
 */ export var Globe = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.856934 11.9998C0.856934 14.9551 2.03091 17.7893 4.1206 19.879C6.21029 21.9687 9.04452 23.1426 11.9998 23.1426C14.9551 23.1426 17.7893 21.9687 19.879 19.879C21.9687 17.7893 23.1426 14.9551 23.1426 11.9998C23.1426 9.04452 21.9687 6.21029 19.879 4.1206C17.7893 2.03091 14.9551 0.856934 11.9998 0.856934C9.04452 0.856934 6.21029 2.03091 4.1206 4.1206C2.03091 6.21029 0.856934 9.04452 0.856934 11.9998V11.9998Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M0.856934 12H23.1426",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.2853 11.9998C16.0744 16.0746 14.5736 19.9768 11.9996 23.1426C9.42559 19.9768 7.92473 16.0746 7.71387 11.9998C7.92473 7.92503 9.42559 4.0228 11.9996 0.856934C14.5736 4.0228 16.0744 7.92503 16.2853 11.9998Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Globe", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
